import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ProjectsHttpService } from '../../state/projects/projects-http.service';
import { UsersHttpService } from '../../state/users/users-http.service';
import { assert } from '../../assert/assert';
import { ProjectModel } from '../../models/project/project.model';
import { UserModel } from '../../models/user/user.model';
import { map, switchMap } from 'rxjs/operators';

export const projectDataResolver: ResolveFn<{ project: ProjectModel; users: UserModel[] }> = (
  _,
  state,
) => {
  const projectsHttpService = inject(ProjectsHttpService);
  const usersHttpService = inject(UsersHttpService);
  const projectId = +state.url.split('/').pop()!;
  assert(!isNaN(projectId), `Project id is not a number: ${projectId}`);

  return usersHttpService.getUsers().pipe(
    // users request is executed and must finish first
    switchMap((users) =>
      projectsHttpService.getSingleProject(projectId).pipe(map((project) => ({ project, users }))),
    ),
  );
};
